export default __webpack_public_path__ + "static/media/ballon.f47b2e76.jpg";